import "./p360SharedView/p360SharedView.sass";
import "./p360ViewManager/p360ViewManager.sass";
import "./b360FilterBar/b360FilterBar.sass";
import "./bFilterTree/bFilterTree.sass";
import "./b360ViewFilterGroup/b360ViewFilterGroup.sass";
import "./b360Widgets/b360Widgets.sass";
import "./bChartShareDialog/bChartShareDialog.sass";
import "./bVolumeSlicerTable/bVolumeSlicerTable.sass";

import "./charts/bBarChartWithLegend/bBarChartWithLegend.sass";
import "./charts/bEmployeeRoleChart/bEmployeeRoleChart.sass";
import "./charts/bLinePlusBarChart/bLinePlusBarChart.sass";
import "./charts/bLineChart/bLineChart.sass";
import "./charts/bProcessGroupChart/bProcessGroupChart.sass";
import "./charts/bProcessProblemsChart/bProcessProblemsChart.sass";
import "./charts/bVaAndNvaChart/bVaAndNvaChart.sass";

import {p360SharedViewDirective} from './p360SharedView/p360SharedView.directive';
import {p360ViewManagerDirective} from './p360ViewManager/p360ViewManager.directive';
import {b360FilterBarDirective} from './b360FilterBar/b360FilterBar.directive';
import {bFilterTreeDirective} from './bFilterTree/bFilterTree.directive';
import {b360ViewFilterGroupDirective} from './b360ViewFilterGroup/b360ViewFilterGroup.directive';
import {b360WidgetsDirective} from './b360Widgets/b360Widgets.directive';
import {bChartShareDialogDirective} from './bChartShareDialog/bChartShareDialog.directive';
import {bVolumeSlicerTableDirective} from './bVolumeSlicerTable/bVolumeSlicerTable.directive';

import {
  bBarChartWithLegendDirective, bEmployeeRoleChartDirective, bLineChartDirective, bLinePlusBarChartDirective,
  bProcessGroupChartDirective, bProcessProblemsChartDirective, bVaAndNvaChartDirective
} from './charts';

import {ClientsService} from './clients.service';

export default angular.module('frontend.360view', ["frontend.auth", "frontend.theme", "nvd3"])
  .directive('p360SharedView', p360SharedViewDirective)
  .directive('p360ViewManager', p360ViewManagerDirective)
  .directive("b360FilterBar", b360FilterBarDirective)
  .directive("bFilterTree", bFilterTreeDirective)
  .directive('b360ViewFilterGroup', b360ViewFilterGroupDirective)
  .directive('b360Widgets', b360WidgetsDirective)
  .directive('bBarChartWithLegend', bBarChartWithLegendDirective)
  .directive('bChartShareDialog', bChartShareDialogDirective)
  .directive('bEmployeeRoleChart', bEmployeeRoleChartDirective)
  .directive('bLineChart', bLineChartDirective)
  .directive('bLinePlusBarChart', bLinePlusBarChartDirective)
  .directive('bProcessGroupChart', bProcessGroupChartDirective)
  .directive('bProcessProblemsChart', bProcessProblemsChartDirective)
  .directive('bVaAndNvaChart', bVaAndNvaChartDirective)
  .directive('bVolumeSlicerTable', bVolumeSlicerTableDirective)
  .service('Clients', ClientsService);
